import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { useRef, useState, useCallback, useImperativeHandle } from 'react';
import { useClickAway } from 'react-use';
import { Layout, Button, Field, ArrowIcon, DropDown } from './styles.js';
import { ReactComponent as SvgArrowBottomIcon } from '../../../assets/icons/arrow-bottom-icon.svg.js';
import { Typography } from '@mui/material';
import { defaultDropDownStyle } from './types.js';

var MenuDropDown = function (_a, innerRef) {
    var title = _a.title, _b = _a.focused, focused = _b === void 0 ? false : _b, _c = _a.secondaryTitle, secondaryTitle = _c === void 0 ? null : _c, children = _a.children, dropDownStyle = _a.dropDownStyle, id = _a.id, className = _a.className;
    var style = __assign(__assign({}, defaultDropDownStyle), dropDownStyle);
    var menuRef = useRef(null);
    var _d = useState(false), isActiveDropDown = _d[0], setActiveDropDown = _d[1];
    var handleActiveDropDown = useCallback(function () {
        setActiveDropDown(function (active) { return !active; });
    }, []);
    useClickAway(menuRef, function () {
        setActiveDropDown(false);
    });
    useImperativeHandle(innerRef, function () { return ({
        setIsDropDownActive: function (isActive) {
            setActiveDropDown(isActive);
        },
    }); });
    return (React__default.createElement(Layout, { ref: menuRef, id: id, className: className },
        React__default.createElement(Button, { focused: focused, center: !secondaryTitle, isActiveDropDown: isActiveDropDown, onClick: handleActiveDropDown },
            React__default.createElement(Field, null,
                secondaryTitle && (React__default.createElement(Typography, { color: "neutral400", variant: "caption", component: "p" }, secondaryTitle)),
                React__default.createElement(Typography, { sx: {
                        fontWeight: 400,
                        color: function (theme) {
                            return !secondaryTitle
                                ? theme.palette.neutral300
                                : "".concat(theme.palette.neutral100, " !important");
                        },
                    }, fontWeight: 400, variant: "h3", component: "span" }, title)),
            React__default.createElement(ArrowIcon, null,
                React__default.createElement(SvgArrowBottomIcon, null))),
        isActiveDropDown && React__default.createElement(DropDown, { style: style }, children)));
};
var MenuDropDown$1 = React__default.forwardRef(MenuDropDown);

export { MenuDropDown$1 as default };
